// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"fee5753d","115":"f7a7a73f","154":"f7a7a73f","311":"f7a7a73f","435":"f7a7a73f","659":"c7242a34","975":"f7a7a73f"}[chunkId] + ".chunk.css";
};